import { jsx } from "react/jsx-runtime";
import { ResponsiveIframe } from "@zillow/zrs-cms";
import { omit } from "lodash";
import PropTypes from "prop-types";
import "react";
import { usePlacement } from "../../components/PlacementProvider/PlacementProvider.esm.js";
const BlockVimeo = ({
  attrs
}) => {
  const {
    width = 1024,
    height = 768,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    url,
    videoId,
    autoplay = 0,
    controls = 1,
    loop = 0,
    dnt = 0,
    loading = "lazy",
    title = "Vimeo video player",
    ...iframeAttributes
  } = attrs;
  const embedUrl = new URL(`https://player.vimeo.com/video/${videoId}`);
  embedUrl.searchParams.append("autoplay", autoplay ? "1" : "0");
  embedUrl.searchParams.append("muted", autoplay ? "1" : "0");
  embedUrl.searchParams.append("loop", loop ? "1" : "0");
  embedUrl.searchParams.append("controls", controls ? "1" : "0");
  embedUrl.searchParams.append("dnt", dnt ? "1" : "0");
  const isPost = usePlacement() === "post";
  return /* @__PURE__ */ jsx(ResponsiveIframe, { src: embedUrl.href, title, allowFullScreen: true, loading, width, height, ...omit(iframeAttributes, "margin"), ...isPost ? {
    marginBottom: "md"
  } : iframeAttributes.margin });
};
BlockVimeo.propTypes = {
  attrs: PropTypes.shape({
    url: PropTypes.string,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    videoId: PropTypes.number,
    autoplay: PropTypes.bool,
    controls: PropTypes.bool,
    loop: PropTypes.bool,
    dnt: PropTypes.bool,
    loading: PropTypes.string,
    title: PropTypes.string
  }),
  index: PropTypes.number
};
export {
  BlockVimeo as default
};
